import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useUsers } from "@/contexts/users-provider";
import { TeamUserRolesEnum } from "@/enums/team-user-role";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamKnowledgeFileDTO } from "@shaarp/common";
import { useEffect } from "react";
import ShaarpLogo from "./../../assets/shaarp-logo.svg";

export default function DataTableCellTeamKnowledgeFileCreatedBy({
  file,
}: {
  file: TeamKnowledgeFileDTO;
}) {
  const { users, apiFetchUsers } = useUsers();
  const { t } = useTranslation();

  useEffect(() => {
    const init = async () => {
      await apiFetchUsers();
    };
    init();
  }, []);

  // Find the user in the team users list
  const user = users.find((u) => u.id === file.createdBy);

  if (!user) {
    return (
      <div className="flex items-center">
        <Avatar className="w-8 h-8">
          <AvatarFallback className="text-xs">
            {file.createdBy.slice(0, 2).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <span className="ml-2 text-muted-foreground text-sm">
          {t("team.knowledge.dataTable.unknownUser")}
        </span>
      </div>
    );
  }

  if (user.role === TeamUserRolesEnum.ADMIN) {
    return (
      <div className="flex items-center">
        <Avatar className="w-9 h-9">
          <AvatarImage src={ShaarpLogo} alt={"Shaarp"} />
        </Avatar>
        <span className="ml-2">
          {t("team.knowledge.dataTable.administrator")}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <Avatar className="w-8 h-8">
        <AvatarImage src={user.imageUrl} alt={user.fullName} />
        <AvatarFallback className="text-xs">
          {user.fullName
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase()
            .slice(0, 2)}
        </AvatarFallback>
      </Avatar>
      <span className="ml-2 text-sm">{user.fullName}</span>
    </div>
  );
}
